module["exports"] = [
  "no",
  "com",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/internet/domain_suffix.js
// module id = 2510
// module chunks = 2